import { message, notification } from 'antd';
import axios from 'axios';
import React from 'react';
import MasterLayout from './components/master_layout';
import './layout.css';
import { store } from '../store';
import { set_auth } from '../actions/auth.action';
import authService from '../services/admin/auth.service';

// NOTE: This interceptor is re-registered on every render of LayoutIndex (pre-existing issue).
// The totp2faRedirectPending flag is module-level so all registered instances share it,
// ensuring only one redirect fires per page load regardless of re-registrations.
let totp2faRedirectPending = false;

const LayoutIndex = ({children}) => {

    //auto error message
    axios.interceptors.response.use(function (response) {
    // Do something with response data
        return response;
        }, async function (error) {
        if(error?.response){
            const err_message = (error?.response?.data?.message);
            if(401 === error.response.status){
                if(!totp2faRedirectPending && error?.response?.data?.require_totp_setup === true){
                    totp2faRedirectPending = true;
                    store.dispatch(set_auth(null));
                    sessionStorage.setItem('totp_flash', 'Two-factor authentication is now required. Please log in to set it up.');
                    // Await logout with a 2-second timeout so we never hang on a slow/failed request.
                    await Promise.race([
                        authService.logout().catch(() => {}),
                        new Promise(resolve => setTimeout(resolve, 2000)),
                    ]);
                    if(window.location.pathname !== '/login'){
                        window.location.href = '/login';
                    }
                    return Promise.reject(error);
                }
                // Other 401s: existing behaviour — fall through → resolves as undefined.
            }
            else if(422 === error.response.status){
            notification.error({
                message : err_message,
                duration : 5,
            })
            return Promise.reject(error);
            }
            else{
            // Do something with response error
            // 500
            if(!(error?.request?.responseURL?.includes('fc/recognize'))){
                notification.error({
                    message : err_message,
                    duration : 5,
                })
            }

            return Promise.reject(error);
            }
        }else{
            // Do something with response error
            notification.error({
                message : "Something went wrong, please contact our support",
                duration : 5,
            })
            return Promise.reject(error);
        }
    });
    return (
        <>
            <MasterLayout>
                {children}
            </MasterLayout>
        </>
    );
}

export default LayoutIndex;
